<script setup lang="ts">
import { ref } from 'vue'

export interface NotifyProps {
  type?: 'danger' | 'success' | 'warning' | 'info'
  message: string
  duration?: number
}

const props = withDefaults(defineProps<NotifyProps>(), {
  type: 'danger',
  duration: 3000,
})

const show = ref(false)

const notifyType = {
  danger: 'danger',
  success: 'success',
  warning: 'warning',
  info: 'primary',
} as const

const iconName = {
  danger: 'close',
  success: 'success',
  warning: 'warning-o',
  info: 'info-o',
} as const

const open = () => {
  show.value = true
}

const close = () => {
  show.value = false
}

const autoClose = () => {
  setTimeout(close, props.duration)
}

defineExpose({
  open,
  close,
})
</script>

<template>
  <van-notify
    v-model:show="show"
    :type="notifyType[type]"
    :duration="duration"
    class-name="custom-notify"
    @opened="autoClose"
  >
    <van-icon :name="iconName[type]" class="size-5 text-xl mr-1 icon" />
    <div class="text-base font-semibold text-left flex-1">{{ message }}</div>
  </van-notify>
</template>

<style scoped>
/* 组件级样式可以在这里添加 */
</style>
